import {inject, injectable} from "inversify";
import SERVICE_IDENTIFIER from "../container/identifiers";
import {EventEmitter} from "../service/event-emitter";
import EVENTS from "../container/events";
import {Component} from "../interface/component";

@injectable()
export class EventsDetailComponent implements Component {

    private $root:JQuery;
    private $modal:JQuery;
    @inject(SERVICE_IDENTIFIER.EVENTS) public eventEmitter: EventEmitter;
    private html: string;
    private stack: string[] = [];
    private pageTitle: string;

    init(elem:HTMLElement) {
        let pageTitle = document.title;
        this.$root = $(elem);
        this.html = this.$root.html();
        this.bindUI();
    }

    /**
     * Sets up fancy box for this gallery. Sets up filter functionality.
     */
    private bindUI() {
        this.eventEmitter.addListener(EVENTS.HANDLE_EVENT_DETAIL, this.showEventDetail);
        this.eventEmitter.addListener(EVENTS.SHOW_EVENT_MODAL, this.showModel);
        this.eventEmitter.addListener(EVENTS.DESTROY_EVENT_MODAL, this.destroyReveal);
        if (this.$root.data('show_on_load')) {
            this.eventEmitter.emit(EVENTS.SHOW_EVENT_MODAL);
        }
    }

    /**
     * Show the event detail
     * @param response
     */
    private showEventDetail = (response:any) => {
        if (undefined === this.$modal || null === this.$modal) {
            this.createModel();
        }
        this.buildReveal(response);
        this.eventEmitter.emit(EVENTS.SHOW_EVENT_MODAL);
    };

    /**
     *
     */
    private showModel = () => {
        if (undefined === this.$modal || null === this.$modal) {
            this.createModel();
        }
        this.$modal.foundation('open');
        $('.reveal-overlay').get(0).scrollTo(0,0);
        this.$modal
            .find('.js-event__close')
            .off({ click: this.destroyReveal })
            .on({ click: this.destroyReveal })
        ;
        this.$modal.find('.js-event__next, .js-event__previous').each((key, item) => {
            if (undefined === $(item).data('id') || '' === $(item).data('id')) {
                $(item).hide();
            } else {
                $(item).show();
            }
        });
        this.$modal.find('.js-event__next, .js-event__previous')
            .off({ click: this.loadNext })
            .on({ click: this.loadNext })
        ;
    };

    protected loadNext = (ev:MouseEvent) => {
        ev.preventDefault();
        let $target = $(ev.currentTarget);
        let id = $target.data('id');
        if (undefined !== id && null !== id){
            this.eventEmitter.emit(EVENTS.EVENT_LOAD_EVENT, id);
        }
    };

    protected createModel = () => {
        this.$modal = $(this.html);
        new Foundation.Reveal(this.$modal, { vOffset: 0 });
    };

    /**
     * Build the reveal module
     * @param responseData:string
     */
    protected buildReveal = (responseData:string) => {
        let response = JSON.parse(responseData);
        this.$modal.html(response.html);
        if ((<any>window).location.pathname !== response.url) {
            this.stack.push(response.url);
            (<any>window).history.pushState({}, response.title + ' | ' + this.pageTitle, response.url);
        }
        if (undefined !== (<any>window).ga) {
            (<any>window).ga('send', 'pageview', response.url);
        }
        if (undefined !== (<any>window).dataLayer) {
            (<any>window).dataLayer.push({
                'event': 'VirtualPageview',
                'virtualPageURL': response.url,
                'virtualPageTitle' : response.title + ' | ' + this.pageTitle
            });
        }
        this.updateOrHideControl(this.$modal.find('.js-event__previous'), response.previous_id);
        this.updateOrHideControl(this.$modal.find('.js-event__next'), response.next_id);
    };

    /**
     * Destroys the modal
     */
    protected destroyReveal = (ev:MouseEvent) => {
        ev.preventDefault();
        if (null !== this.$modal && undefined !== this.$modal) {
            this.stack.forEach(() => (<any>window).history.back());
            this.stack = [];
            (<any>window).history.replaceState({}, this.pageTitle, '/events');
            this.$modal.foundation('close');
        }
    };

    /**
     * Updates and hides the image element depending on the situation
     * @param $modal
     * @param response
     */
    private updateOrHideImages = ($modal:JQuery<HTMLElement>, response:any) => {
        let $contentContainer = $modal.find('.js-event__content-container');
        let $imageContainer = $modal.find('.js-event__image-container');
        if (response.images) {
            $contentContainer
                .removeClass('c-event__content--no-image')
                .addClass('c-event__content--image');
            $imageContainer.removeClass('c-event__image--no-image');
            $modal
                .find('.js-event__image')
                .attr('src', response.image.full);
        } else {
            $imageContainer.addClass('c-event__image--no-image');
        }
    };

    /**
     * Updates or hides a link if no link is available
     * @param $url
     * @param url
     */
    private updateOrHideLink = ($url:JQuery<HTMLElement>, url:string) => {
        if (undefined !== url && '' !== url) {
            $url.show();
            $url.attr('href', url);
        } else {
            $url.hide();
        }
    }

    private updateOrHideControl = ($control:JQuery<HTMLElement>, id:any) => {
        if (null !== id && '' !== id) {
            $control.show();
            $control.data('id', id);
        } else {
            $control.hide();
        }
    }
}